import { AxiosError } from 'axios';
import { IErrorResponse, IApiErrorResponse } from '../interface/main.interface';

/**
 * Normalize an Axios error to IErrorResponse for Redux thunk rejectWithValue.
 * Handles various error response formats from the backend and provides a consistent
 * error response structure.
 *
 * @param err - The caught error (typically unknown type from try/catch)
 * @param fallbackMessage - Default message to use if no message is extracted from the error
 * @returns IErrorResponse with normalized status and message
 */
export function normalizeAxiosError(err: unknown, fallbackMessage: string): IErrorResponse {
  const error = err as AxiosError<IApiErrorResponse>;
  const errorData = error.response?.data || (error as IApiErrorResponse);

  return {
    status: error.response?.status || errorData?.statusCode || 500,
    message: Array.isArray(errorData?.message)
      ? errorData.message.join(', ')
      : errorData?.message || fallbackMessage,
    error: errorData?.error,
  };
}
